module.exports = __webpack_public_path__ + "img/rent-call.090179b5.svg";